var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.1582,
    y: 7.5,
    width: 3.33333,
    height: 3.53968,
    rx: 1.66667,
    transform: "rotate(90 14.1582 7.5)",
    fill: "#F5F4FA",
    stroke: "#5A3DB4",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6992,
    y: 14.1665,
    width: 3.33333,
    height: 3.53968,
    rx: 1.66667,
    transform: "rotate(90 17.6992 14.1665)",
    fill: "#F5F4FA",
    stroke: "#5A3DB4",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42383 3.3335V11.8335C4.42383 13.7191 4.42383 14.6619 5.00961 15.2477C5.5954 15.8335 6.53821 15.8335 8.42383 15.8335H14.158",
    stroke: "#5A3DB4",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42383 5.8335V5.8335C4.42383 7.07965 4.42383 7.70273 4.69178 8.16683C4.86731 8.47087 5.11979 8.72334 5.42383 8.89888C5.88793 9.16683 6.51101 9.16683 7.75716 9.16683H10.6183",
    stroke: "#5A3DB4",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomations);
export default __webpack_public_path__ + "static/media/automations.d5cac4d0d88a7a62c7a8ba4294936fd2.svg";
export { ForwardRef as ReactComponent };